import NavMenuItem from "../ui/nav-menu-item";
import { useState, useContext } from "react";
import SearchModal from "./search-modal";
import UserContext from "../../contexts/user-context";
import BusinessContext from "../../contexts/business-context";
import TableNav from "./table-nav";
import { useRouter } from "next/router";
const NavMenuItems = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dropdownStates, setDropdownStates] = useState({
    workpegAI: false,
    dashboard: false,
  });
  const router = useRouter();
  const userCtx = useContext(UserContext);
  const user = userCtx.user;
  const businessCtx = useContext(BusinessContext);
  const business = businessCtx.activeBusiness;





  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const toggleDropdown = (dropdown) => {
    setDropdownStates((prevState) => ({
      ...prevState,
      [dropdown]: !prevState[dropdown],
    }));
  }
  if (user.is_pseudonymous || business.is_pseudonymous) {
    return (
      <div className="grid gap-[4px] content-start max-h-[70dvh] overflow-y-scroll scrollbar-none">
        <span className="px-[27px] text-[12px] custom-text-grey-800  poppins-regular">
          Get Started
        </span>
        <NavMenuItem icon="badge-check" href="/onboarding">
          Onboard
        </NavMenuItem>
      </div>
    );
  }
  if (router.pathname.includes('/mail')) {
    return null;
  }
  return (
    <div className="grid gap-[4px] content-start max-h-[100vh]">
      <TableNav/>


      {isModalOpen && <SearchModal toggleModal={toggleModal} />}
    </div>
  );
};

export default NavMenuItems;
